import { MmsService } from "interfaces/mms-service"
import { BusinessCardHolderService } from "services/mms/external-api/business/card-holder-service"
import { BusinessProfileService } from "services/mms/external-api/business/profile-service"
import { BusinessStationsService } from "services/mms/external-api/business/stations-services"
import { BusinessInvoiceService } from "./invoice-service"
import { BusinessPaymentService } from "services/mms/external-api/business/payment-service"
import { BusinessRfidService } from "services/mms/external-api/business/rfid-service"
import { BusinessRfidRuleService } from "services/mms/external-api/business/rfidRule-service"
import { BusinessSessionsService } from "services/mms/external-api/business/sessions-service"
import { BusinessChargingRulesService } from "services/mms/external-api/business/charging-rules-service"
import { BusinessOrganizationService } from "services/mms/external-api/business/organization-service"
import { BusinessSupportService } from "services/mms/external-api/business/support-service.ts"


const apiEndpoint = (endpoint: string) => {
    return `/v2/${endpoint}`;
};

export class BusinessMmsService extends MmsService {
    constructor() {
        super({
            cardHolderService: new BusinessCardHolderService(apiEndpoint('card-holders')),
            stationsService: new BusinessStationsService(apiEndpoint('stations/geojson')),
            profileService: new BusinessProfileService(apiEndpoint('profile')),
            invoiceService: new BusinessInvoiceService(apiEndpoint('invoices')),
            rfidService: new BusinessRfidService(apiEndpoint('rfids')),
            rfidRuleService: new BusinessRfidRuleService(apiEndpoint('rfid/rules')),
            paymentService: new BusinessPaymentService(apiEndpoint('payment-methods')),
            sessionsService: new BusinessSessionsService(apiEndpoint('sessions')),
            chargingRulesService: new BusinessChargingRulesService(apiEndpoint('rules')),
            organizationService: new BusinessOrganizationService(apiEndpoint("organizations")),
            supportService: new BusinessSupportService(apiEndpoint("external/support")),
        })
    }
}